<template>
  <div>
    <v-btn v-if="!isViewOnly && showStickySaveButton" color="success" size="large" variant="elevated" @click="Update"
      :loading="dialog" :disabled="dialog" prepend-icon="mdi-content-save" class="save-action-button sticky-save-btn"
      rounded="lg">
      <template v-slot:prepend>
        <v-icon size="20">mdi-content-save</v-icon>
      </template>
      {{ $t("save") }} Configuration
    </v-btn>
    <v-container fluid class="pa-6">
      <!-- Header Section -->
      <div class="page-header" style="margin-bottom: 0px">
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{
            $t("setup_title")
          }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </div>
      <div class="config-grid">
        <v-row v-if="!isViewOnly" justify="end" class="mt-4">
          <v-btn color="success" size="large" variant="elevated" @click="Update" :loading="dialog" :disabled="dialog"
            prepend-icon="mdi-content-save" class="save-action-button" rounded="lg" style="margin-right: 12px">
            <template v-slot:prepend>
              <v-icon size="20">mdi-content-save</v-icon>
            </template>
            {{ $t("save") }} Configuration
          </v-btn>
        </v-row>

        <div>
          <v-container fluid>
            <!-- Platform Selection Tabs -->
            <div class="platform-tabs-container">
              <v-tabs v-model="selectedTab" class="modern-tabs" color="primary" slider-color="primary" centered grow>
                <v-tab v-for="platform in platformConfig" :key="platform.key" :value="platform.key" class="platform-tab"
                  :class="`tab-${platform.key}`">
                  <div class="tab-content">
                    <component :is="platform.icon" v-if="platform.icon === 'LineIcon'" :size="24"
                      color="currentColor" />
                    <v-icon v-else :icon="platform.icon" size="24"></v-icon>
                    <span class="tab-text">{{ platform.name }}</span>
                    <v-chip v-if="getConfigCount(platform.key) > 0" size="small" :color="platform.chipColor"
                      variant="elevated" class="config-count-chip" :class="`chip-${platform.key}`">
                      <v-icon size="12" class="mr-1">mdi-circle-small</v-icon>
                      {{ getConfigCount(platform.key) }}
                    </v-chip>
                  </div>
                </v-tab>
              </v-tabs>

              <!-- Platform Content -->
              <v-window v-model="selectedTab" class="mt-6">
                <!-- LINE Tab -->
                <v-window-item value="line" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large line-gradient">
                        <LineIcon :size="32" color="white" />
                      </div>
                      <div class="platform-details">
                        <h2>LINE Messaging API</h2>
                        <p>
                          Configure LINE Bot integration with channel secrets
                          and tokens
                        </p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="success" variant="flat" size="default" @click="Add('line')"
                          class="compact-text-btn line-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("line")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>

                    <!-- Configurations Grid -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="
                        setupList.filter((item) => item.activeFlag).length ===
                        0
                      " class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-chat-outline</v-icon>
                        </div>
                        <h3>No LINE configurations yet</h3>
                        <p>
                          Create your first LINE bot configuration to get
                          started
                        </p>
                        <v-btn color="success" variant="elevated" size="large" @click="Add('line')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <div v-for="(item, index) in setupList" :key="item.createDate.toString()"
                          v-show="item.activeFlag" class="config-card line-card">
                          <div class="config-card-header">
                            <div class="config-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn icon size="small" variant="text" @click="Delete(item, index)"
                              class="delete-icon-btn">
                              <v-icon color="error">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="primary">mdi-information</v-icon>
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.name" label="Configuration Name" :rules="[rules.required]"
                                    @keypress="specialCharacters($event)" @paste="specialCharactersOnPaste"
                                    variant="outlined" density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter configuration name" color="primary">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="primary">mdi-tag</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete :items="DDGroupModel" item-title="name" item-value="id"
                                    v-model="item.groupModelID" label="Group Model" clearable variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Select group model" color="primary">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="primary">mdi-group</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="warning">mdi-shield-key</v-icon>
                                Authentication Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.secret" label="Channel Secret" :rules="[rules.required]"
                                    variant="outlined" density="comfortable" hide-details="auto" :type="checkSecretVisibility(
                                      'linecs:' + item.secret
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter channel secret"
                                    color="primary">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="warning">mdi-key-variant</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'linecs:' + item.secret,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "linecs:" + item.secret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.token" label="Channel Token" :rules="[rules.required]"
                                    variant="outlined" density="comfortable" hide-details="auto" :type="checkSecretVisibility(
                                      'linetoken:' + item.token
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter channel token"
                                    color="primary">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="info">mdi-shield-key-outline</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'linetoken:' + item.token,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "linetoken:" + item.token
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>

                        <!-- Add New Card -->
                        <div class="add-config-card" @click="Add('line')">
                          <div class="add-card-content">
                            <v-icon size="48" color="success" class="mb-4">mdi-plus-circle</v-icon>
                            <h4>Add New Configuration</h4>
                            <p>Create a new LINE bot configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- MS Teams Tab -->
                <v-window-item value="teams" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large teams-gradient">
                        <v-icon size="32" color="white">mdi-microsoft-teams</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Microsoft Teams</h2>
                        <p>Configure MS Teams</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="purple" variant="flat" size="default" @click="Add('ms')"
                          class="compact-text-btn teams-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("teams")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>

                    <!-- Teams Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="
                        setupListMS.filter((item) => item.activeFlag)
                          .length === 0
                      " class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-microsoft-teams</v-icon>
                        </div>
                        <h3>No Teams configurations yet</h3>
                        <p>
                          Create your first Microsoft Teams bot configuration
                        </p>
                        <v-btn color="purple" variant="elevated" size="large" @click="Add('ms')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <!-- Teams Config Cards -->
                        <div v-for="(item, index) in setupListMS" :key="item.createDate.toString()"
                          v-show="item.activeFlag" class="config-card teams-card">
                          <div class="config-card-header">
                            <div class="config-badge teams-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn icon size="small" variant="text" @click="Delete(item, index)"
                              class="delete-icon-btn">
                              <v-icon color="error">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="purple">mdi-information</v-icon>
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.name" label="Configuration Name" :rules="[
                                    rules.required,
                                    (v) =>
                                      (v && v.length <= 100) ||
                                      'Max 100 characters',
                                  ]" @keypress="specialCharacters($event)" variant="outlined" density="comfortable"
                                    hide-details="auto" class="modern-field" placeholder="Enter configuration name">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple">mdi-tag</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete :items="DDGroupModel" item-title="name" item-value="id"
                                    v-model="item.groupModelID" label="Group Model" clearable variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Select group model">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple">mdi-group</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Teams Configuration -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="purple">mdi-microsoft-teams</v-icon>
                                Teams Configuration
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-autocomplete :items="DDModelQuickGroup" item-title="name" item-value="id"
                                    v-model="item.modelQuickGroupID" label="Model Shortcut" clearable variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Select quick group model">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple">mdi-lightning-bolt</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete :items="DDShortcuts" item-title="name" item-value="id"
                                    v-model="item.shortcutMenuGroupID" label="Shortcut Menu" clearable
                                    variant="outlined" density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Select shortcut menu">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="purple">mdi-menu</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Generated Link -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="info">mdi-link-variant</v-icon>
                                Generated Link
                              </h4>
                              <v-text-field v-model="setupLinkMS[index]" label="Integration Link" variant="outlined"
                                density="comfortable" readonly hide-details="auto" class="modern-field">
                                <template v-slot:prepend-inner>
                                  <v-icon size="20" color="info">mdi-link</v-icon>
                                </template>
                                <template v-slot:append-inner>
                                  <v-btn icon variant="text" size="small" @click="ClipboardAPIKey(index)">
                                    <v-icon size="16" color="purple">mdi-content-copy</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('ms')">
                          <div class="add-card-content">
                            <v-icon size="48" color="purple" class="mb-4">mdi-plus-circle</v-icon>
                            <h4>Add New Configuration</h4>
                            <p>Create a new Teams bot configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Facebook Tab -->
                <v-window-item value="facebook" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large facebook-gradient">
                        <v-icon size="32" color="white">mdi-facebook</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Facebook Messenger</h2>
                        <p>Configure Facebook integration</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="blue" variant="flat" size="default" @click="Add('facebook')"
                          class="compact-text-btn facebook-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("facebook")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>

                    <!-- Facebook Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="
                        setupListFacebook.filter((item) => item.activeFlag)
                          .length === 0
                      " class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-facebook</v-icon>
                        </div>
                        <h3>No Facebook configurations yet</h3>
                        <p>
                          Create your first Facebook Messenger bot configuration
                        </p>
                        <v-btn color="blue" variant="elevated" size="large" @click="Add('facebook')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <div v-for="(item, index) in setupListFacebook" :key="item.createDate.toString()"
                          v-show="item.activeFlag" class="config-card facebook-card">
                          <div class="config-card-header">
                            <div class="config-badge facebook-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn icon size="small" variant="text" @click="Delete(item, index)"
                              class="delete-icon-btn">
                              <v-icon color="error">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="indigo">mdi-information</v-icon>
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.name" label="Configuration Name" :rules="[
                                    rules.required,
                                    (v) =>
                                      (v && v.length <= 100) ||
                                      'Max 100 characters',
                                  ]" @keypress="specialCharacters($event)" variant="outlined" density="comfortable"
                                    hide-details="auto" class="modern-field" placeholder="Enter configuration name">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo">mdi-tag</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete :items="DDGroupModel" item-title="name" item-value="id"
                                    v-model="item.groupModelID" label="Group Model" clearable variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Select group model">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo">mdi-group</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Authentication Details -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="indigo">mdi-shield-key</v-icon>
                                Authentication Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.secret" label="Facebook Verify Token"
                                    :rules="[rules.required]" variant="outlined" density="comfortable"
                                    hide-details="auto" :type="checkSecretVisibility(
                                      'fbverify:' + item.secret
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter verify token">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo">mdi-shield-check</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'fbverify:' + item.secret,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "fbverify:" + item.secret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.token" label="Facebook Access Token"
                                    :rules="[rules.required]" variant="outlined" density="comfortable"
                                    hide-details="auto" :type="checkSecretVisibility(
                                      'fbtoken:' + item.token
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter access token">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo">mdi-key</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'fbtoken:' + item.token,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "fbtoken:" + item.token
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field v-model="item.appSecret" label="Facebook App Secret" variant="outlined"
                                    density="comfortable" persistent-hint
                                    hint="ใช้ตรวจลายเซ็น X-Hub-Signature-256 ของ webhook — ไม่กรอกจะรับ webhook เส้น Salesforce ไม่ได้ (ค่าคนละตัวกับ Verify Token)"
                                    :type="checkSecretVisibility(
                                      'fbappsecret:' + item.appSecret
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter app secret">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo">mdi-fingerprint</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'fbappsecret:' + item.appSecret,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "fbappsecret:" + item.appSecret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- API Configuration -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="indigo">mdi-api</v-icon>
                                API Configuration
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.apI_Version" label="API Version" variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter API version (e.g., v18.0)">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo">mdi-api</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.pageID" label="Page ID" :rules="[rules.required]"
                                    variant="outlined" density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter Facebook Page ID">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="indigo">mdi-identifier</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('facebook')">
                          <div class="add-card-content">
                            <v-icon size="48" color="blue" class="mb-4">mdi-plus-circle</v-icon>
                            <h4>Add New Configuration</h4>
                            <p>Create a new Facebook bot configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- Instagram Tab -->
                <v-window-item value="instagram" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large instagram-gradient">
                        <v-icon size="32" color="white">mdi-instagram</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Instagram Messaging</h2>
                        <p>Configure Instagram for direct messages</p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="pink" variant="flat" size="default" @click="Add('instagram')"
                          class="compact-text-btn instagram-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("instagram")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>

                    <!-- Instagram Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="
                        setupListInstagram.filter((item) => item.activeFlag)
                          .length === 0
                      " class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-instagram</v-icon>
                        </div>
                        <h3>No Instagram configurations yet</h3>
                        <p>
                          Create your first Instagram messaging bot
                          configuration
                        </p>
                        <v-btn color="pink" variant="elevated" size="large" @click="Add('instagram')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <div v-for="(item, index) in setupListInstagram" :key="item.createDate.toString()"
                          v-show="item.activeFlag" class="config-card instagram-card">
                          <div class="config-card-header">
                            <div class="config-badge instagram-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn icon size="small" variant="text" @click="Delete(item, index)"
                              class="delete-icon-btn">
                              <v-icon color="error">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="pink">mdi-information</v-icon>
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.name" label="Configuration Name" :rules="[
                                    rules.required,
                                    (v) =>
                                      (v && v.length <= 100) ||
                                      'Max 100 characters',
                                  ]" @keypress="specialCharacters($event)" variant="outlined" density="comfortable"
                                    hide-details="auto" class="modern-field" placeholder="Enter configuration name">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink">mdi-tag</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete :items="DDGroupModel" item-title="name" item-value="id"
                                    v-model="item.groupModelID" label="Group Model" clearable variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Select group model">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink">mdi-group</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Authentication Details -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="pink">mdi-shield-key</v-icon>
                                Authentication Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.secret" label="Instagram Verify Token"
                                    :rules="[rules.required]" variant="outlined" density="comfortable"
                                    hide-details="auto" :type="checkSecretVisibility(
                                      'igverify:' + item.secret
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter verify token">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink">mdi-shield-check</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'igverify:' + item.secret,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "igverify:" + item.secret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.token" label="Instagram Access Token"
                                    :rules="[rules.required]" variant="outlined" density="comfortable"
                                    hide-details="auto" :type="checkSecretVisibility(
                                      'igtoken:' + item.token
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter access token">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink">mdi-key</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'igtoken:' + item.token,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "igtoken:" + item.token
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field v-model="item.appSecret" label="Instagram App Secret" variant="outlined"
                                    density="comfortable" persistent-hint
                                    hint="ใช้ตรวจลายเซ็น X-Hub-Signature-256 ของ webhook — ไม่กรอกจะรับ webhook เส้น Salesforce ไม่ได้ (ค่าคนละตัวกับ Verify Token)"
                                    :type="checkSecretVisibility(
                                      'igappsecret:' + item.appSecret
                                    )
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field" placeholder="Enter app secret">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink">mdi-fingerprint</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small" @click="
                                        toggleSecretVisibility(
                                          'igappsecret:' + item.appSecret,
                                          $event
                                        )
                                        ">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility(
                                              "igappsecret:" + item.appSecret
                                            )
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- API Configuration -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="pink">mdi-api</v-icon>
                                API Configuration
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.apI_Version" label="API Version" variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter API version (e.g., v18.0)">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink">mdi-api</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.pageID" label="Page ID" variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter Instagram Page ID">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="pink">mdi-identifier</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('instagram')">
                          <div class="add-card-content">
                            <v-icon size="48" color="pink" class="mb-4">mdi-plus-circle</v-icon>
                            <h4>Add New Configuration</h4>
                            <p>Create a new Instagram bot configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>

                <!-- TikTok Tab — แท็บเดียว เลือกระบบจาก dropdown ในการ์ด -->
                <v-window-item value="tiktok" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large tiktok-gradient">
                        <v-icon size="32" color="white">mdi-music-note</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>TikTok</h2>
                        <p>
                          เลือกได้ต่อ config ว่าเป็น Shop (แชทผู้ซื้อในร้าน)
                          หรือ Business (DM จากผู้ชมคลิป) — สองระบบนี้ใช้
                          credential คนละชุดและใช้แทนกันไม่ได้
                        </p>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{ getConfigCount("tiktok") }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>

                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="tiktokList.filter((item) => item.activeFlag).length === 0" class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-music-note</v-icon>
                        </div>
                        <h3>No TikTok configurations yet</h3>
                        <p>Create your first TikTok configuration</p>
                        <v-btn color="black" variant="elevated" size="large" @click="Add('tiktok')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <div v-for="(item, index) in tiktokList" :key="item.createDate.toString()"
                          v-show="item.activeFlag" class="config-card" :class="item.typeSocial + '-card'">
                          <div class="config-card-header">
                            <div class="config-badge tiktok-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-chip size="small" variant="elevated" class="ml-2 tiktok-type-chip">
                              {{
                                item.typeSocial === "tt_shop"
                                  ? "Shop"
                                  : "Business"
                              }}
                            </v-chip>
                            <v-spacer />
                            <v-btn icon size="small" variant="text" @click="Delete(item, index)"
                              class="delete-icon-btn">
                              <v-icon color="error">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- ขั้นที่ 1 — แยกออกมาเป็นแถวของตัวเอง เพราะทุกช่องด้านล่าง
                                 เปลี่ยนความหมายตามค่านี้ ต้องเลือกให้จบก่อนถึงจะกรอกถูก -->
                            <div class="form-section tiktok-system-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="black">mdi-numeric-1-circle</v-icon>
                                เลือกระบบก่อน
                                <span class="section-subtitle">
                                  Shop กับ Business ใช้ credential คนละชุด
                                  ช่องกรอกด้านล่างจะเปลี่ยนตามที่เลือก
                                </span>
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12">
                                  <v-select
                                    :items="tiktokSystems"
                                    item-title="text"
                                    item-value="value"
                                    v-model="item.typeSocial"
                                    label="TikTok System"
                                    :rules="[rules.required]"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field tiktok-system-field"
                                    @update:modelValue="TikTokSystemChanged(item)"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="black">mdi-swap-horizontal</v-icon>
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>
                            </div>

                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="black">mdi-numeric-2-circle</v-icon>
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field
                                    v-model="item.name"
                                    label="Configuration Name"
                                    :rules="[
                                      rules.required,
                                      (v) => (v && v.length <= 100) || 'Max 100 characters',
                                    ]"
                                    @keypress="specialCharacters($event)"
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Enter configuration name"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="black">mdi-tag</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete
                                    :items="DDGroupModel"
                                    item-title="name"
                                    item-value="id"
                                    v-model="item.groupModelID"
                                    label="Group Model"
                                    clearable
                                    variant="outlined"
                                    density="comfortable"
                                    hide-details="auto"
                                    class="modern-field"
                                    placeholder="Select group model"
                                  >
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="black">mdi-group</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="black">mdi-numeric-3-circle</v-icon>
                                Authentication Details
                                <span class="section-subtitle">
                                  ({{
                                    item.typeSocial === "tt_shop"
                                      ? "partner.tiktokshop.com"
                                      : "business-api.tiktok.com"
                                  }})
                                </span>
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.token" label="App Key / App ID" :rules="[rules.required]"
                                    variant="outlined" density="comfortable" persistent-hint
                                    hint="Shop = App Key (client ID) · Business = App ID จาก business-api.tiktok.com/portal/apps"
                                    :type="checkSecretVisibility('ttkey:' + item.token)
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="black">mdi-key</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small"
                                        @click="toggleSecretVisibility('ttkey:' + item.token, $event)">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility('ttkey:' + item.token)
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.appSecret" label="App Secret" :rules="[rules.required]"
                                    variant="outlined" density="comfortable" persistent-hint
                                    hint="Shop = ใช้ทั้งคำนวณ sign ทุก request และตรวจลายเซ็น webhook · Business = ใช้ตรวจลายเซ็น webhook อย่างเดียว"
                                    :type="checkSecretVisibility('ttsecret:' + item.appSecret)
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="black">mdi-fingerprint</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small"
                                        @click="toggleSecretVisibility('ttsecret:' + item.appSecret, $event)">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility('ttsecret:' + item.appSecret)
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" v-if="item.typeSocial === 'tt_shop'">
                                  <v-text-field v-model="item.secret" label="Service ID" :rules="[rules.required]"
                                    variant="outlined" density="comfortable" persistent-hint
                                    hint="เฉพาะ TikTok Shop — ใช้สร้าง authorize URL · อยู่ใต้ชื่อ app ตรง label &quot;ID:&quot; ไม่ได้อยู่ในแท็บไหน"
                                    :type="checkSecretVisibility('ttservice:' + item.secret)
                                      ? 'text'
                                      : 'password'
                                      " class="modern-field secure-field">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="black">mdi-identifier</v-icon>
                                    </template>
                                    <template v-slot:append-inner>
                                      <v-btn icon variant="text" size="small"
                                        @click="toggleSecretVisibility('ttservice:' + item.secret, $event)">
                                        <v-icon size="16">
                                          {{
                                            checkSecretVisibility('ttservice:' + item.secret)
                                              ? "mdi-eye"
                                              : "mdi-eye-off"
                                          }}
                                        </v-icon>
                                      </v-btn>
                                    </template>
                                  </v-text-field>
                                </v-col>

                              </v-row>
                            </div>
                            <!-- ขั้นที่ 4 — เชื่อมต่อกับร้าน (เฉพาะ Shop)
                                 ⚠️ App Key/Secret/Service ID ที่กรอกด้านบนเป็นแค่กุญแจ
                                 ตัวที่เอาไปยิงจริง (access_token + shop_cipher) ต้องกด Connect เอามา -->
                            <div
                              v-if="item.typeSocial === 'tt_shop' && item.socialID"
                              class="form-section tiktok-connect-section"
                            >
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="black">mdi-numeric-4-circle</v-icon>
                                เชื่อมต่อร้าน
                                <span class="section-subtitle">
                                  กรอกช่องด้านบนให้ครบแล้วกด Save Configuration ก่อน จึงจะกด Connect ได้
                                </span>
                              </h4>

                              <div class="mt-3">
                                <!-- เชื่อมแล้ว -->
                                <template v-if="TikTokStatusOf(item.socialID).isConnected">
                                  <div class="d-flex align-center flex-wrap ga-2 mb-2">
                                    <v-chip size="small" color="success" variant="elevated">
                                      <v-icon size="14" class="mr-1">mdi-check-circle</v-icon>
                                      เชื่อมต่อแล้ว
                                    </v-chip>
                                    <span class="text-body-2">
                                      shop_id: <strong>{{ TikTokStatusOf(item.socialID).shopId || "-" }}</strong>
                                      · region: <strong>{{ TikTokStatusOf(item.socialID).region || "-" }}</strong>
                                    </span>
                                  </div>

                                  <v-alert
                                    :type="TikTokExpiryTone(item.socialID)"
                                    variant="tonal"
                                    density="compact"
                                    class="mb-3"
                                  >
                                    {{ TikTokExpiryText(item.socialID) }}
                                  </v-alert>

                                  <div class="d-flex ga-2">
                                    <v-btn
                                      size="small"
                                      variant="tonal"
                                      color="primary"
                                      :disabled="isViewOnly"
                                      :loading="tiktokBusy === item.socialID"
                                      @click="TikTokStartConnect(item)"
                                    >
                                      <v-icon size="16" class="mr-1">mdi-autorenew</v-icon>
                                      เชื่อมต่อใหม่
                                    </v-btn>
                                    <v-btn
                                      size="small"
                                      variant="tonal"
                                      color="error"
                                      :disabled="isViewOnly"
                                      :loading="tiktokBusy === item.socialID"
                                      @click="TikTokDisconnect(item)"
                                    >
                                      <v-icon size="16" class="mr-1">mdi-link-off</v-icon>
                                      ตัดการเชื่อมต่อ
                                    </v-btn>
                                  </div>
                                </template>

                                <!-- ยังไม่เชื่อม -->
                                <template v-else>
                                  <v-alert type="warning" variant="tonal" density="compact" class="mb-3">
                                    ยังไม่ได้เชื่อมต่อ — ตอบลูกค้าไม่ได้จนกว่าจะกด Connect
                                    เพราะยังไม่มี access_token และ shop_cipher
                                  </v-alert>
                                  <v-btn
                                    color="primary"
                                    variant="flat"
                                    rounded="lg"
                                    :disabled="isViewOnly"
                                    :loading="tiktokBusy === item.socialID"
                                    @click="TikTokStartConnect(item)"
                                  >
                                    <v-icon size="18" class="mr-2">mdi-link-variant</v-icon>
                                    Connect
                                  </v-btn>
                                </template>
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('tiktok')">
                          <div class="add-card-content">
                            <v-icon size="48" color="black" class="mb-4">mdi-plus-circle</v-icon>
                            <h4>Add New Configuration</h4>
                            <p>Create a new TikTok configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Dialog ขั้นตอน Connect (ข้อ 7.1 ขั้น 1-4) -->
                  <v-dialog v-model="tiktokDialog" max-width="640" persistent>
                    <v-card rounded="lg">
                      <v-card-title class="text-h6">เชื่อมต่อ TikTok Shop</v-card-title>
                      <v-card-text>
                        <ol class="text-body-2 tiktok-steps">
                          <li class="mb-3">
                            เปิดหน้า authorize แล้ว login ด้วยบัญชี seller ของร้าน
                            <div class="mt-2">
                              <v-btn
                                size="small"
                                color="primary"
                                variant="flat"
                                :href="tiktokAuthorizeUrl"
                                target="_blank"
                                rel="noopener"
                                :disabled="!tiktokAuthorizeUrl"
                              >
                                <v-icon size="16" class="mr-1">mdi-open-in-new</v-icon>
                                เปิดหน้า authorize
                              </v-btn>
                            </div>
                          </li>
                          <li class="mb-3">
                            หลังกดอนุมัติ TikTok จะ redirect กลับพร้อม
                            <code>auth_code</code> ใน URL — คัดลอกค่านั้นมาวางด้านล่าง
                            <div class="text-caption text-medium-emphasis mt-1">
                              ⚠️ auth_code ใช้ได้ครั้งเดียวและหมดอายุเร็ว ถ้าช้าไปให้กดขอใหม่
                            </div>
                          </li>
                        </ol>

                        <v-text-field
                          v-model="tiktokAuthCode"
                          label="auth_code"
                          variant="outlined"
                          density="comfortable"
                          hide-details="auto"
                          class="mt-2"
                        />

                        <v-alert
                          v-if="tiktokError"
                          type="error"
                          variant="tonal"
                          density="compact"
                          class="mt-4"
                        >
                          <div class="text-body-2">{{ tiktokError }}</div>
                          <div v-if="tiktokErrorRequestId" class="text-caption mt-1">
                            request_id: <code>{{ tiktokErrorRequestId }}</code>
                          </div>
                        </v-alert>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer />
                        <v-btn variant="text" @click="tiktokDialog = false">
                          {{ $t("cancel") }}
                        </v-btn>
                        <v-btn
                          color="primary"
                          variant="flat"
                          :loading="tiktokBusy !== null"
                          @click="TikTokConfirmConnect"
                        >
                          เชื่อมต่อ
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                </v-window-item>

                <!-- Snippet Tab -->
                <v-window-item value="snippet" class="platform-window">
                  <div class="platform-content-wrapper">
                    <div class="platform-header-info">
                      <div class="platform-icon-large snippet-gradient">
                        <v-icon size="32" color="white">mdi-code-tags</v-icon>
                      </div>
                      <div class="platform-details">
                        <h2>Web Snippet Integration</h2>
                        <p>
                          Configure web snippet for website chatbot integration
                        </p>
                      </div>
                      <div class="platform-actions" v-if="false">
                        <v-btn color="orange" variant="flat" size="default" @click="Add('snippet')"
                          class="compact-text-btn snippet-btn" rounded="lg">
                          <v-icon size="18" class="mr-2">mdi-plus</v-icon>
                          Add Config
                        </v-btn>
                      </div>
                      <div class="platform-stats">
                        <div class="stat-item">
                          <span class="stat-number">{{
                            getConfigCount("snippet")
                          }}</span>
                          <span class="stat-label">Configurations</span>
                        </div>
                      </div>
                    </div>

                    <!-- Snippet Configurations -->
                    <div v-if="chkDataLine" class="configurations-grid">
                      <div v-if="
                        setupListSnippet.filter((item) => item.activeFlag)
                          .length === 0
                      " class="empty-state-card">
                        <div class="empty-icon">
                          <v-icon size="64" color="grey-lighten-2">mdi-code-tags</v-icon>
                        </div>
                        <h3>No Snippet configurations yet</h3>
                        <p>Create your first web snippet configuration</p>
                        <v-btn color="orange" variant="elevated" size="large" @click="Add('snippet')" class="mt-4">
                          <v-icon left>mdi-plus</v-icon>
                          Create First Configuration
                        </v-btn>
                      </div>

                      <div v-else class="config-cards-container">
                        <div v-for="(item, index) in setupListSnippet" :key="item.createDate.toString()"
                          v-show="item.activeFlag" class="config-card snippet-card">
                          <div class="config-card-header">
                            <div class="config-badge snippet-badge">
                              <v-icon small class="mr-1">mdi-cog</v-icon>
                              Config #{{ index + 1 }}
                            </div>
                            <v-btn icon size="small" variant="text" @click="Delete(item, index)"
                              class="delete-icon-btn">
                              <v-icon color="error">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>

                          <div class="config-card-body">
                            <!-- Basic Information -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="orange">mdi-web-box</v-icon>
                                Basic Information
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.name" label="Domain Name" :rules="[
                                    rules.required,
                                    (v) =>
                                      (v && v.length <= 100) ||
                                      'Max 100 characters',
                                  ]" @keypress="specialCharactersDomain($event)" variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter domain name">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange">mdi-web</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-autocomplete :items="listDDModel" item-title="name" item-value="modelDisplayID"
                                    v-model="item.modelDisplayID" label="Model Display" required variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Select model display">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange">mdi-brain</v-icon>
                                    </template>
                                  </v-autocomplete>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Configuration Details -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="orange">mdi-cog-outline</v-icon>
                                Configuration Details
                              </h4>
                              <v-row class="mt-2">
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.token" label="Token" variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter token (optional)">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange">mdi-key</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                  <v-text-field v-model="item.lineUserID" label="User Default" variant="outlined"
                                    density="comfortable" hide-details="auto" class="modern-field"
                                    placeholder="Enter default user ID">
                                    <template v-slot:prepend-inner>
                                      <v-icon size="20" color="orange">mdi-account</v-icon>
                                    </template>
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </div>

                            <!-- Generated Resources -->
                            <div class="form-section">
                              <h4 class="section-title">
                                <v-icon small class="mr-2" color="info">mdi-link-variant</v-icon>
                                Generated Resources
                              </h4>
                              <v-text-field v-model="item.link" label="Integration Link" variant="outlined"
                                density="comfortable" readonly hide-details="auto" class="modern-field"
                                placeholder="Generated integration link">
                                <template v-slot:prepend-inner>
                                  <v-icon size="20" color="info">mdi-link</v-icon>
                                </template>
                                <template v-slot:append-inner>
                                  <v-btn icon variant="text" size="small" @click="ClipboardScriptSnippet(index)">
                                    <v-icon size="16" color="orange">mdi-content-copy</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                            </div>
                          </div>
                        </div>

                        <div class="add-config-card" @click="Add('snippet')">
                          <div class="add-card-content">
                            <v-icon size="48" color="orange" class="mb-4">mdi-plus-circle</v-icon>
                            <h4>Add New Configuration</h4>
                            <p>Create a new Snippet configuration</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-window-item>
              </v-window>
            </div>
          </v-container>
        </div>
      </div>
    </v-container>

    <!-- Loading Overlay -->
    <v-overlay :value="dialog" color="primary" opacity="0.8">
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="white" width="4"></v-progress-circular>
        <p class="white--text mt-4 subtitle-1">Loading...</p>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import LineIcon from "@/components/icons/LineIcon.vue";
// import checkPermissionFour from "@/api/function.js";
import LogTrace from "@/api/function.js";
import { mask } from "vue-the-mask";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "SetupSocial",
  inject: ["flagNav", "FontColorTitle", "SubNavbarBackGround"],
  mixins: [LogTrace],
  components: {
    LineIcon,
  },
  directives: {
    mask,
  },
  data: () => ({
    mask: "##########",
    showStickySaveButton: false,
    scrollThreshold: 145,
    selectedTab: "line",
    platformConfig: [
      {
        key: "line",
        name: "LINE",
        icon: "LineIcon",
        chipColor: "success",
        gradient: "line-gradient",
      },
      {
        key: "teams",
        name: "Teams",
        icon: "mdi-microsoft-teams",
        chipColor: "purple",
        gradient: "teams-gradient",
      },
      {
        key: "facebook",
        name: "Facebook",
        icon: "mdi-facebook",
        chipColor: "blue",
        gradient: "facebook-gradient",
      },
      {
        key: "instagram",
        name: "Instagram",
        icon: "mdi-instagram",
        chipColor: "pink",
        gradient: "instagram-gradient",
      },
      // TikTok = แท็บเดียว แต่ 1 config เลือกได้ว่าเป็น Shop หรือ Business
      // สองระบบไม่แชร์ credential และใช้แทนกันไม่ได้ (PRD ข้อ 4) -> เก็บเป็นคนละ
      // TypeSocial ในฐานข้อมูล (tt_shop / tt_biz) ผู้ใช้เลือกเองจาก dropdown
      // ไม่ใช่ระบบ detect ให้ ซึ่งเป็นสิ่งที่ PRD ข้อ 7.1 ห้ามไว้
      // ⚠️ MDI 7.x ไม่มีไอคอน tiktok (ถอดออกด้วยเหตุผลเครื่องหมายการค้า) จึงใช้ไอคอนแทน
      {
        key: "tiktok",
        name: "TikTok",
        icon: "mdi-music-note",
        chipColor: "grey-darken-4",
        gradient: "tiktok-gradient",
      },
      {
        key: "snippet",
        name: "Snippet",
        icon: "mdi-code-tags",
        chipColor: "orange",
        gradient: "snippet-gradient",
      },
    ],
    headers: [],
    items: [],
    panel: [0],
    show1: false,
    formHasErrors: false,
    showSecretKey: [],
    expandedPlatforms: {
      line: true,
      teams: false,
      facebook: false,
      instagram: false,
      tiktok: false,
      snippet: false,
    },
    permission: {
      add: true,
      edit: true,
      delete: true,
    },
    mailcheck: false,
    phonecheck: false,
    chkDataLine: false,

    DDModelQuickGroup: [],

    DDGroupModel: [],
    DDShortcuts: [],
    numberRules: [(v) => !!v || "Input is required!"],
    rules: {
      required: (value) => !!value || "Required.",
    },
    Email: null,
    gg: null,
    UserType: null,
    dialog: false,
    edit: {
      id: null,
      key: null,
      value: null,
    },
    user: {
      id: null,
      key: null,
      value: null,
    },

    Editdialog: false,
    Adddialog: false,
    isSearch: false,
    searchname: "",
    email: "",
    totalTable: 0,
    itemsPerPage: 10,
    options: {},
    today: null,
    setupListGeneral: [],
    setupGeneral: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      azureContainer: null,
      languageTranslatorKey: null,
      languageTranslatorLocation: null,
      languageKey: null,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      hostName: null,
      password: null,
      openAIAPIKey: null,
      openAIUrl: null,
      speechToTextKey: null,
      speechToTextRegion: null,
      speechToTextLanguage: null,
      pathFFMpeg: null,
      pathFFMpegLocal: null,
      autoStream: null,
    },
    setupList: [],
    setupListMS: [],
    setupListSnippet: [],
    setupListFacebook: [],
    setupListInstagram: [],

    // TikTok เก็บ config ใน sy.SocialSettings เหมือนช่องทางอื่นทุกประการ
    // แยก 2 ระบบตาม PRD ข้อ 4 — คนละ credential คนละ portal ใช้แทนกันไม่ได้
    //   tt_shop      token=App Key · appSecret=App Secret · secret=Service ID
    //   tt_biz  token=App ID  · appSecret=App Secret · (ไม่มี Service ID)
    tiktokList: [],
    // สถานะการเชื่อมต่อรายแถว (มาจาก /api/v1/TikTokOAuth/Status) — ไม่มี token อยู่ในนี้
    tiktokStatus: [],
    tiktokDialog: false,
    tiktokAuthorizeUrl: null,
    tiktokAuthCode: "",
    tiktokSocialId: null,
    tiktokBusy: null,
    tiktokError: null,
    tiktokErrorRequestId: null,
    // ตัวเลือกใน dropdown ของการ์ด — value ตรงกับคอลัมน์ TypeSocial ในฐานข้อมูล
    tiktokSystems: [
      { text: "TikTok Shop", value: "tt_shop" },
      { text: "TikTok Business", value: "tt_biz" },
    ],
    setupLinkMS: [],
    setup: {
      azureOpenAI_URL: null,
      azureOpenAI_APIKey: null,
      azureStorageConnection: null,
      azureContainer: null,
      languageTranslatorKey: null,
      languageTranslatorLocation: null,
      languageKey: null,
      languageEndpoint: null,
      channelSecretInternal: null,
      channelTokenInternal: null,
      emailHost: null,
      hostName: null,
      password: null,
      openAIAPIKey: null,
      openAIUrl: null,
    },
    secretKey: "01234567890123456789012345678901",
    specialCharacter: /[!@#$%^&*(),.?":{}|<>+`~ ]/,
    specialCharacterDomain: /[!@#$%^&*(),?":{}|<>+`~ ]/,
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    listDDModel: [],
  }),
  watch: {},
  mounted() {
    this.GetDate();
    this.Get();
    this.GetModel();

    const scroller = document.querySelector(".v-main__scroller") || window;
    scroller.addEventListener("scroll", this.handleScroll, true);
    this._scrollContainer = scroller;
  },
  unmounted() {
    // ลบ listener ออกจาก container ที่แท้จริง
    if (this._scrollContainer) {
      this._scrollContainer.removeEventListener(
        "scroll",
        this.handleScroll,
        true
      );
    }
  },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('SetupSocial');
    },
    form() {
      return {
        id: this.user.id,
        key: this.user.key,
        value: this.user.value,
      };
    },
  },

  methods: {
    handleScroll(event) {
      const openAutocomplete = document.querySelector(
        ".v-overlay--active .v-list"
      );
      if (openAutocomplete) {
        return;
      }
      const { scrollTop } = event.target;
      if (scrollTop >= this.scrollThreshold) {
        this.showStickySaveButton = true;
      } else {
        this.showStickySaveButton = false;
      }
    },
    toggleSecretVisibility(key, event) {
      event.preventDefault();
      event.stopPropagation();
      const inputElement = event.target
        .closest(".v-field")
        .querySelector("input");
      if (inputElement) {
        inputElement.blur();
      }

      if (this.showSecretKey.includes(key)) {
        this.showSecretKey.splice(this.showSecretKey.indexOf(key), 1);
      } else {
        this.showSecretKey.push(key);
      }
    },
    checkSecretVisibility(key) {
      return this.showSecretKey.includes(key);
    },
    toggleExpansion(platform) {
      this.expandedPlatforms[platform] = !this.expandedPlatforms[platform];
    },
    getConfigCount(platform) {
      switch (platform) {
        case "line":
          return this.setupList.filter((item) => item.activeFlag).length;
        case "teams":
          return this.setupListMS.filter((item) => item.activeFlag).length;
        case "facebook":
          return this.setupListFacebook.filter((item) => item.activeFlag)
            .length;
        case "tiktok":
          return this.tiktokList.filter((item) => item.activeFlag).length;
        case "instagram":
          return this.setupListInstagram.filter((item) => item.activeFlag)
            .length;
        case "snippet":
          return this.setupListSnippet.filter((item) => item.activeFlag).length;
        default:
          return 0;
      }
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    // ── TikTok OAuth · PRD-tiktok-channel.md ข้อ 7.1 ────────────────────────
    TikTokLoadStatus() {
      let self = this;
      self.$call.GetTikTokStatus(
        (dataResponse) => {
          if (dataResponse.status == 0 && Array.isArray(dataResponse.data)) {
            self.tiktokStatus = dataResponse.data;
          }
        },
        (errorResource) => {
          // ไม่เด้ง popup — แท็บอื่นยังใช้งานได้ปกติถ้า TikTok ยังไม่พร้อม
          console.error(errorResource);
        }
      );
    },
    TikTokStatusOf(socialId) {
      return (
        this.tiktokStatus.find((s) => s.socialId === socialId) || {
          isConnected: false,
        }
      );
    },
    /// สี alert ตามความเร่งด่วนของวันหมดอายุ
    TikTokExpiryTone(socialId) {
      const st = this.TikTokStatusOf(socialId);
      if (st.needsReconnect) return "error";
      const d = st.expiresInDays;
      if (d === null || d === undefined) return "info";
      if (d < 1) return "error";
      if (d < 3) return "warning";
      return "success";
    },
    TikTokExpiryText(socialId) {
      const st = this.TikTokStatusOf(socialId);
      if (st.needsReconnect) {
        return "token หมดอายุแล้ว หรือไม่มี refresh token — ต้องกดเชื่อมต่อใหม่";
      }
      const d = st.expiresInDays;
      if (d === null || d === undefined) return "ไม่ทราบวันหมดอายุของ token";
      if (d < 0) return "token หมดอายุแล้ว — ต้องกดเชื่อมต่อใหม่";
      // ระบบต่ออายุให้เองก่อนส่งข้อความถ้าเหลือไม่ถึง 1 วัน
      return `token หมดอายุในอีก ${d.toFixed(1)} วัน (ระบบต่ออายุให้อัตโนมัติก่อนส่งข้อความ)`;
    },
    TikTokStartConnect(item) {
      let self = this;
      self.tiktokSocialId = item.socialID;
      self.tiktokAuthCode = "";
      self.tiktokError = null;
      self.tiktokErrorRequestId = null;
      self.tiktokAuthorizeUrl = null;
      self.tiktokBusy = item.socialID;

      self.$call.GetTikTokAuthorizeUrl(
        item.socialID,
        (dataResponse) => {
          self.tiktokBusy = null;
          const data = dataResponse.data;
          if (data && data.authorizeUrl) {
            self.tiktokAuthorizeUrl = data.authorizeUrl;
            self.tiktokDialog = true;
          } else {
            self.$swal.fire({
              icon: "warning",
              title: "ยังเชื่อมต่อไม่ได้",
              text: (data && data.blockedReason) || "สร้างลิงก์ authorize ไม่สำเร็จ",
            });
          }
        },
        (errorResource) => {
          self.tiktokBusy = null;
          console.error(errorResource);
        }
      );
    },
    TikTokConfirmConnect() {
      let self = this;
      const code = (self.tiktokAuthCode || "").trim();
      if (!code) {
        self.tiktokError = "กรุณาวาง auth_code ที่ได้จาก redirect URL";
        return;
      }

      self.tiktokBusy = self.tiktokSocialId;
      self.tiktokError = null;
      self.tiktokErrorRequestId = null;

      self.$call.ConnectTikTok(
        { socialId: self.tiktokSocialId, authCode: code },
        (dataResponse) => {
          self.tiktokBusy = null;
          const result = dataResponse.data;
          if (result && result.isSuccess) {
            self.tiktokDialog = false;
            self.$swal.fire({
              icon: "success",
              title: "เชื่อมต่อสำเร็จ",
              text: result.shopName || "TikTok Shop",
              showConfirmButton: false,
              timer: 2000,
            });
            self.TikTokLoadStatus();
          } else {
            // ⚠️ backend คืน 200 พร้อม isSuccess=false เพื่อให้เราอ่าน errorCode/requestId ได้
            self.tiktokError = (result && result.message) || "เชื่อมต่อไม่สำเร็จ";
            self.tiktokErrorRequestId = result ? result.requestId : null;
          }
        },
        (errorResource) => {
          self.tiktokBusy = null;
          self.tiktokError = "เรียก API ไม่สำเร็จ";
          console.error(errorResource);
        }
      );
    },
    TikTokDisconnect(item) {
      let self = this;
      self.$swal
        .fire({
          icon: "warning",
          title: "ตัดการเชื่อมต่อ?",
          text: "ร้านนี้จะหยุดรับ-ส่งข้อความ และ token จะถูกลบทิ้ง (App Key/Secret ที่กรอกไว้ยังอยู่)",
          showCancelButton: true,
        })
        .then((res) => {
          if (!res.isConfirmed) return;
          self.tiktokBusy = item.socialID;
          self.$call.DisconnectTikTok(
            item.socialID,
            () => {
              self.tiktokBusy = null;
              self.TikTokLoadStatus();
            },
            (errorResource) => {
              self.tiktokBusy = null;
              console.error(errorResource);
            }
          );
        });
    },
    TikTokSystemChanged(item) {
      // Business ไม่มี Service ID (PRD A.4) — ล้างทิ้งตอนสลับ ไม่งั้นค่าเก่าจะถูกบันทึก
      // ไปกับแถว Business ทั้งที่ช่องถูกซ่อนไปแล้ว (ผู้ใช้มองไม่เห็นว่ายังมีค่าค้างอยู่)
      if (item.typeSocial === "tt_biz") {
        item.secret = null;
      }
    },
    Get() {
      try {
        let self = this;
        self.dialog = true;
        self.$call.GetOverviewSocial(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              let data = dataResponse.data;
              self.setupList = data.filter((e) => e.typeSocial == "line");
              self.setupListMS = data.filter((e) => e.typeSocial == "ms");
              self.setupListSnippet = data.filter(
                (e) => e.typeSocial == "snippet"
              );
              self.setupListFacebook = data.filter(
                (e) => e.typeSocial == "facebook"
              );
              self.setupListInstagram = data.filter(
                (e) => e.typeSocial == "instagram"
              );
              // สองระบบอยู่แท็บเดียวกัน แยกกันที่ค่า typeSocial ของแต่ละแถว
              self.tiktokList = data.filter(
                (e) =>
                  e.typeSocial == "tt_shop" ||
                  e.typeSocial == "tt_biz"
              );
              self.setupLinkMS = [];
              self.setupListMS.forEach((element) => {
                var temp = element.name.split("`");
                element.name = temp[0];
                self.setupLinkMS.push(temp[1]);
              });
              self.setupListSnippet.map((el) => {
                let temp = el.name.split("`");
                el.name = temp[0];
                el.link = temp[1];
                return {
                  ...el,
                };
              });
            }
            self.dialog = false;
            self.isSearch = false;
            self.chkDataLine = true;
            self.GetDDGroupModel();
            self.GetDDShortcutMenu();
            self.GetDDModelQuickGroup();
            self.TikTokLoadStatus();
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            self.chkDataLine = true;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetGeneral() {
      try {
        let self = this;
        self.$call.GetSetupOverview(
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.setupListGeneral = dataResponse.data;
              self.MapSetupList(self.setupListGeneral, false);
            }
            self.dialog = false;
            self.isSearch = false;
            self.Get();
          },
          (errorResource) => {
            self.dialog = false;
            self.isSearch = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "Get");
      }
    },
    GetDDGroupModel() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDGroupModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDGroupModel = dataResponse.data;
          } else {
            self.DDGroupModel = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDShortcutMenu() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDShortcutMenu(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDShortcuts = dataResponse.data;
          } else {
            self.DDShortcuts = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    GetDDModelQuickGroup() {
      let self = this;
      self.dialog = true;
      self.$call.GetDDModelQuickGroup(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDModelQuickGroup = dataResponse.data;
          } else {
            self.DDModelQuickGroup = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },

    MapSetupList(source, mapForSave) {
      let self = this;
      source.forEach((element) => {
        switch (element.key) {
          case "ChannelSecret_Internal":
            element.value = mapForSave
              ? self.setupGeneral.channelSecretInternal
              : element.value;
            self.setupGeneral.channelSecretInternal = element.value;
            break;
          case "ChannelToken_Internal":
            element.value = mapForSave
              ? self.setupGeneral.channelTokenInternal
              : element.value;
            self.setupGeneral.channelTokenInternal = element.value;
            break;

          default:
            break;
        }
      });
    },
    EditUser(temp) {
      let self = this;
      self.edit.id = temp.id;
      self.edit.key = temp.key;
      self.edit.value = temp.value;

      self.Editdialog = true;
    },
    validateNameLength() {
      let self = this;
      const lists = [
        self.setupList,
        self.setupListMS,
        self.setupListSnippet,
        self.setupListFacebook,
        self.setupListInstagram,
        self.tiktokList,
      ];
      for (const list of lists) {
        ;
        for (const item of list) {
          if (item.name && item.name.length > 100) {
            return false;
          }
        }
      }
      return true;
    },
    Update() {
      try {
        let self = this;
        self.dialog = true;

        if (!this.validateNameLength()) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: "Name must be less than 100 characters",
            showConfirmButton: false,
            timer: 2000,
          });
          self.dialog = false;
          return;
        }

        if (
          !self.Validate(self.setupList) ||
          !self.Validate(self.setupListMS) ||
          !self.Validate(self.setupListSnippet) ||
          !self.Validate(self.setupListFacebook) ||
          !self.Validate(self.setupListInstagram) ||
          !self.Validate(self.tiktokList)
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 2000,
          });
          self.dialog = false;
          return;
        }
        if (!self.ValidateSpecialCharacters(self.setupListMS)) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningSpecialCharacters"),
            showConfirmButton: false,
            timer: 2000,
          });
          self.dialog = false;
          return;
        }
        self.setupList.push(...self.setupListMS);
        self.setupList.push(...self.setupListSnippet);
        self.setupList.push(...self.setupListFacebook);
        self.setupList.push(...self.setupListInstagram);
        self.setupList.push(...self.tiktokList);
        // self.setupList.map((item)=>(item.modelDisplayID == 'null' ? null : item.modelDisplayID));
        self.$call.UpdateSocial(
          self.setupList,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              //self.UpdateLineGeneral();
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
                backdrop: false
              });
              self.GetGeneral();
            } else if (dataResponse.status == 3) {
              self.$swal.fire({
                icon: "warning",
                title: self.$t("warning"),
                text: self.$t("warningDuplicateDomain"),
                showConfirmButton: false,
                timer: 2000,
              });
              self.dialog = false;
            } else self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    UpdateLineGeneral() {
      try {
        let self = this;
        self.dialog = true;
        self.MapSetupList(self.setupListGeneral, true);
        self.$call.GetSetupUpdate(
          self.setupListGeneral,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.$swal.fire({
                icon: "success",
                title: dataResponse.message,
                showConfirmButton: false,
                timer: 1500,
              });
              self.GetGeneral();
            }
            self.dialog = false;
          },
          (errorResource) => {
            self.dialog = false;
            console.error(errorResource);
          }
        );
      } catch (error) {
        this.LogTrace(error, "UpdateUser");
      }
    },
    Add(type) {
      let self = this;
      let temp = {
        socialID: 0,
        name: null,
        secret: null,
        token: null,
        typeSocial: type,
        groupModelID: null,
        createDate: new Date(),
        createBy: null,
        activeFlag: true,
        modelDisplayID: null,
      };
      if (type == "line") {
        self.setupList.push(temp);
      } else if (type == "ms") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          shortcutMenuGroupID: null,
        };

        self.setupListMS.push(temp);
      } else if (type == "snippet") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
        };
        self.setupListSnippet.push(temp);
      } else if (type == "facebook") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          appSecret: null,
          apI_Version: null,
          pageID: null,
        };

        self.setupListFacebook.push(temp);
      } else if (type == "instagram") {
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: type,
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          appSecret: null,
          apI_Version: null,
          pageID: null,
        };

        self.setupListInstagram.push(temp);
      } else if (type == "tiktok") {
        // ทรงเดียวกับช่องทางอื่น — ต่างกันแค่ความหมายของแต่ละคอลัมน์
        //   shop     : token=App Key · appSecret=App Secret · secret=Service ID
        //   business : token=App ID  · appSecret=App Secret · secret ไม่ใช้
        // ตั้งต้นเป็น Shop (ขอบเขต Phase 1) ผู้ใช้เปลี่ยนได้จาก dropdown ในการ์ด
        temp = {
          socialID: 0,
          name: null,
          secret: null,
          token: null,
          typeSocial: "tt_shop",
          groupModelID: null,
          modelQuickGroupID: null,
          createDate: new Date(),
          createBy: null,
          activeFlag: true,
          modelDisplayID: null,
          appSecret: null,
          apI_Version: null,
          pageID: null,
        };

        self.tiktokList.push(temp);
      }
    },
    Delete(source, index) {
      let self = this;
      self.$swal
        .fire({
          title: this.$t("confirmDeletion"),
          text: this.$t("confirmDeletionSetting"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: this.$t("confirm"),
          cancelButtonText: this.$t("cancel"),
          reverseButtons: false,
        })
        .then((result) => {
          if (result.isConfirmed) {
            source.activeFlag = false;
            if (source.socialID == 0) {
              if (source.typeSocial == "line") {
                self.setupList.splice(index, 1);
              } else if (source.typeSocial == "ms") {
                self.setupListMS.splice(index, 1);
              } else if (source.typeSocial == "snippet") {
                self.setupListSnippet.splice(index, 1);
              } else if (source.typeSocial == "facebook") {
                self.setupListFacebook.splice(index, 1);
              } else if (source.typeSocial == "instagram") {
                self.setupListInstagram.splice(index, 1);
              } else if (
                source.typeSocial == "tt_shop" ||
                source.typeSocial == "tt_biz"
              ) {
                self.tiktokList.splice(index, 1);
              }
            }
          }
        });
    },
    Validate(data) {
      for (const element of data) {
        let temp = element;
        if (temp.activeFlag == true) {
          if (
            temp.name == null ||
            temp.name == "" ||
            (temp.secret == null && temp.typeSocial == "line") ||
            (temp.secret == "" && temp.typeSocial == "line") ||
            (temp.token == null && temp.typeSocial == "line") ||
            (temp.token == "" && temp.typeSocial == "line") ||
            (temp.modelDisplayID == null && temp.typeSocial == "snippet") ||
            (temp.secret == null && temp.typeSocial == "facebook") ||
            (temp.secret == "" && temp.typeSocial == "facebook") ||
            (temp.token == null && temp.typeSocial == "facebook") ||
            (temp.token == "" && temp.typeSocial == "facebook") ||
            (temp.pageID == null && temp.typeSocial == "facebook") ||
            (temp.pageID == "" && temp.typeSocial == "facebook") ||
            (temp.secret == null && temp.typeSocial == "instagram") ||
            (temp.secret == "" && temp.typeSocial == "instagram") ||
            (temp.token == null && temp.typeSocial == "instagram") ||
            (temp.token == "" && temp.typeSocial == "instagram") ||
            (temp.pageID == null && temp.typeSocial == "instagram") ||
            (temp.pageID == "" && temp.typeSocial == "instagram") ||
            // TikTok Shop ต้องครบ 3 ตัว: App Key (token) · App Secret · Service ID (secret)
            (!temp.token && temp.typeSocial == "tt_shop") ||
            (!temp.appSecret && temp.typeSocial == "tt_shop") ||
            (!temp.secret && temp.typeSocial == "tt_shop") ||
            // Business ไม่มี Service ID (PRD A.4) จึงไม่บังคับ secret
            (!temp.token && temp.typeSocial == "tt_biz") ||
            (!temp.appSecret && temp.typeSocial == "tt_biz")
          ) {
            return false;
          }
        }
      }
      return true;
    },
    ValidateSpecialCharacters(data) {
      let self = this;
      for (const element of data) {
        let temp = element;
        if (self.checkSpecialCharacters(temp.name)) {
          return false;
        }
      }
      return true;
    },
    specialCharacters: function (evt) {
      evt = evt || window.event;
      if (this.specialCharacter.test(evt.key)) {
        evt.preventDefault();
      }
    },
    specialCharactersDomain: function (evt) {
      evt = evt || window.event;
      if (this.specialCharacterDomain.test(evt.key)) {
        evt.preventDefault();
      }
    },
    checkSpecialCharacters: function (text) {
      return this.specialCharacter.test(text);
    },
    specialCharactersOnPaste(evt) {
      let clipboardData = evt.clipboardData || window.clipboardData;
      let pastedData = clipboardData.getData("Text");

      if (this.specialCharacter.test(pastedData)) {
        evt.preventDefault();
        this.$swal.fire({
          icon: "warning",
          title: this.$t("warning"),
          text: this.$t("warningSpecialCharacters"),
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    ClipboardAPIKey(index) {
      let text = this.setupLinkMS[index];
      navigator.clipboard.writeText(text);
    },
    ClipboardScriptSnippet(index) {
      let text = this.setupListSnippet[index].link;
      navigator.clipboard.writeText(text);
    },
    async GetModel() {
      let self = this;
      await self.$call.DDGPTModel(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.listDDModel = dataResponse.data;
          } else {
            self.listDDModel = [];
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },
  },
};
</script>
<style scoped>
/* =================== BASE STYLES =================== */
.setup-social {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
}

.title {
  color: white;
}

.config-grid {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* =================== SAVE BUTTON STYLES =================== */
.save-action-button {
  min-width: 200px !important;
  height: 48px !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.save-action-button:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(24, 83, 192, 0.35) !important;
}

.save-action-button:active {
  transform: translateY(0) !important;
}

.save-action-button .v-btn__prepend {
  margin-right: 8px;
}

.sticky-save-btn {
  position: fixed;
  top: 130px;
  right: 30px;
  z-index: 1000;
  max-width: 800px;
  box-shadow: 0px 6px 12px rgba(8, 36, 87, 0.4) !important;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  animation: slideInFromRight 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.sticky-save-btn:hover {
  transform: translateX(-5px) scale(1.02);
  box-shadow: 0px 12px 20px rgba(14, 69, 133, 0.5) !important;
}

@keyframes slideInFromRight {
  from {
    opacity: 0;
    visibility: hidden;
    transform: translateX(100px);
  }

  to {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
}

/* =================== TABS STYLES =================== */
.platform-tabs-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.modern-tabs {
  --v-tabs-height: 90px;
}

.modern-tabs :deep(.v-tabs) {
  height: 50px !important;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-bottom: 1px solid rgba(226, 232, 240, 0.8);
}

.modern-tabs :deep(.v-tabs-slider) {
  transition: transform 0.15s ease-out !important;
}

.platform-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  min-height: 64px !important;
  padding: 5px 24px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.tab-content {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
}

.tab-text {
  font-size: 0.875rem;
  font-weight: 600;
}

/* Tab Active Colors */
.tab-line :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%) !important;
  color: #15803d !important;
  transition: all 0.1s ease-out !important;
}

.tab-teams :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%) !important;
  color: #7c3aed !important;
  transition: all 0.1s ease-out !important;
}

.tab-facebook :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%) !important;
  color: #2563eb !important;
  transition: all 0.1s ease-out !important;
}

.tab-instagram :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%) !important;
  color: #db2777 !important;
  transition: all 0.1s ease-out !important;
}

.tab-snippet :deep(.v-tab--selected) {
  background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%) !important;
  color: #ea580c !important;
  transition: all 0.1s ease-out !important;
}

/* =================== PLATFORM CONTENT =================== */
.platform-window {
  min-height: 600px;
}

.platform-content-wrapper {
  padding: 32px;
}

.platform-header-info {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  border-radius: 16px;
  margin-bottom: 32px;
  border: 1px solid rgba(226, 232, 240, 0.8);
}

.platform-icon-large {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.platform-details {
  flex: 1;
}

.platform-details h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
}

.platform-details p {
  color: #6b7280;
  font-size: 1rem;
  margin: 0;
}

.platform-stats {
  display: flex;
  gap: 24px;
}

.stat-item {
  text-align: center;
  padding: 16px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  min-width: 80px;
}

.stat-number {
  display: block;
  font-size: 1.75rem;
  font-weight: 700;
  color: #1f2937;
}

.stat-label {
  display: block;
  font-size: 0.75rem;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}

/* =================== PLATFORM GRADIENTS =================== */
.line-gradient {
  background: linear-gradient(135deg, #10b951 0%, #059629 100%);
}

.teams-gradient {
  background: linear-gradient(135deg, #665cf6 0%, #3a64ed 100%);
}

.facebook-gradient {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
}

/* TikTok — แท็บเดียว · สีขอบการ์ดบอกว่าแถวนั้นเป็น Shop หรือ Business */
.tiktok-gradient {
  background: linear-gradient(135deg, #25f4ee 0%, #000000 55%, #fe2c55 100%);
}

.tt_shop-card {
  border-left: 4px solid #fe2c55;
}

.tt_biz-card {
  border-left: 4px solid #25f4ee;
}

.tiktok-badge {
  background: linear-gradient(135deg, #25f4ee 0%, #000000 55%, #fe2c55 100%);
}

.tiktok-type-chip {
  background: #000000 !important;
  color: #ffffff !important;
}

.chip-tiktok {
  background: #000000 !important;
}

/* ขั้นที่ 1 ต้องอ่านออกทันทีว่าให้ทำก่อน — พื้นหลังจาง + เส้นซ้าย */
.tiktok-connect-section {
  background: rgba(37, 244, 238, 0.06);
  border-left: 3px solid #25f4ee;
  border-radius: 8px;
  padding: 12px 16px;
}
.tiktok-system-section {
  background: rgba(0, 0, 0, 0.03);
  border-left: 3px solid #fe2c55;
  border-radius: 8px;
  padding: 12px 16px;
}
.section-subtitle {
  font-weight: 400;
  font-size: 0.75rem;
  opacity: 0.6;
  margin-left: 6px;
}

.instagram-gradient {
  background: linear-gradient(45deg, #ffe714 10%, #f01859 50%, #9f00e9 100%);
}

.snippet-gradient {
  background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
}

/* =================== CONFIG CARDS =================== */
.configurations-grid {
  min-height: 400px;
}

.config-cards-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}

.config-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 2px solid transparent;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  animation: slideInUp 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.config-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.12);
}

.config-card:nth-child(2) {
  animation-delay: 0.1s;
}

.config-card:nth-child(3) {
  animation-delay: 0.2s;
}

.config-card:nth-child(4) {
  animation-delay: 0.3s;
}

.config-card:nth-child(5) {
  animation-delay: 0.3s;
}

.config-card:nth-child(6) {
  animation-delay: 0.3s;
}

/* Platform Specific Card Colors */
.line-card {
  border-top: 4px solid #24b910;
}

.line-card:hover {
  border-color: #1eb910;
  box-shadow: 0 12px 30px rgba(16, 185, 30, 0.1);
}

.teams-card {
  border-top: 4px solid #8b5cf6;
}

.teams-card:hover {
  border-color: #8b5cf6;
  box-shadow: 0 12px 30px rgba(139, 92, 246, 0.15);
}

.facebook-card {
  border-top: 4px solid #3b82f6;
}

.facebook-card:hover {
  border-color: #3b82f6;
  box-shadow: 0 12px 30px rgba(59, 130, 246, 0.15);
}

.instagram-card {
  border-top: 4px solid #ec4899;
}

.instagram-card:hover {
  border-color: #ec4899;
  box-shadow: 0 12px 30px rgba(236, 72, 153, 0.15);
}

.snippet-card {
  border-top: 4px solid #f97316;
}

.snippet-card:hover {
  border-color: #f97316;
  box-shadow: 0 12px 30px rgba(249, 115, 22, 0.15);
}

.config-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px 16px 24px;
  border-bottom: 1px solid #f1f5f9;
}

.config-badge {
  display: inline-flex;
  align-items: center;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  color: #475569;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.8125rem;
  font-weight: 600;
}

.teams-badge {
  background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);
  color: #7c3aed;
}

.facebook-badge {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
}

.instagram-badge {
  background: linear-gradient(135deg, #fce7f3 0%, #fbcfe8 100%);
  color: #db2777;
}

.snippet-badge {
  background: linear-gradient(135deg, #fed7aa 0%, #fdba74 100%);
  color: #ea580c;
}

.delete-icon-btn {
  transition: all 0.3s ease;
}

.delete-icon-btn:hover {
  background: rgba(239, 68, 68, 0.1) !important;
  transform: scale(1.1);
}

.config-card-body {
  padding: 24px;
}

/* =================== FORM SECTIONS =================== */
.form-section {
  margin-bottom: 32px;
}

.form-section:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f1f5f9;
}

/* =================== MODERN INPUT STYLES =================== */
.modern-field :deep(.v-field) {
  background: #fafbfc;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.modern-field :deep(.v-field:hover) {
  background: #f8fafc;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.modern-field :deep(.v-field--focused) {
  background: white;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

.secure-field :deep(.v-field) {
  background: linear-gradient(135deg, #fef7ed 0%, #ffffff 100%);
}

/* =================== ADD CONFIG CARD =================== */
.add-config-card {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 2px dashed #cbd5e1;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.add-config-card:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-color: #94a3b8;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}

.add-card-content {
  text-align: center;
  padding: 32px;
}

.add-card-content h4 {
  font-size: 1.25rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.add-card-content p {
  color: #6b7280;
  margin: 0;
}

/* =================== EMPTY STATE =================== */
.empty-state-card {
  background: white;
  border-radius: 16px;
  padding: 64px 32px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #f1f5f9;
}

.empty-icon {
  margin-bottom: 24px;
}

.empty-state-card h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.empty-state-card p {
  color: #6b7280;
  font-size: 1rem;
  margin: 0 0 32px 0;
}

.config-count-chip {
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  height: 24px !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.config-count-chip:hover {
  transform: scale(1.1) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
}

/* Platform Specific Chip Styles */
.chip-line {
  background: linear-gradient(135deg, #10b951 0%, #059629 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-teams {
  background: linear-gradient(135deg, #665cf6 0%, #3a64ed 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-facebook {
  background: linear-gradient(135deg, #3b82f6, #2563eb) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-instagram {
  background: linear-gradient(120deg, #f01872 0%, #db2754 100%) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

.chip-snippet {
  background: linear-gradient(135deg, #f97316, #ea580c) !important;
  color: white !important;
  border: 2px solid rgba(255, 255, 255, 0.2) !important;
}

/* Tab positioning adjustment for absolute positioned chip */
.platform-tab {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
  min-height: 64px !important;
  padding: 5px 24px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative !important;
  /* เพื่อให้ chip อยู่ในตำแหน่งที่ถูกต้อง */
}

/* =================== ANIMATIONS =================== */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* =================== RESPONSIVE DESIGN =================== */
@media (max-width: 960px) {
  .sticky-save-btn {
    width: 200px;
    right: 20px;
    top: 120px;
  }

  .platform-header-info {
    flex-direction: column;
    text-align: center;
    gap: 16px;
  }

  .platform-stats {
    justify-content: center;
  }

  .config-cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .config-cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .platform-tabs-container :deep(.v-tabs) {
    overflow-x: auto;
  }

  .platform-content-wrapper {
    padding: 16px;
  }

  .tab-content {
    flex-direction: row;
  }

  .tab-text {
    display: none;
  }
}

@media (max-width: 600px) {
  .sticky-save-btn {
    width: 180px;
    right: 15px;
    top: 100px;
    font-size: 0.9rem !important;
  }

  .save-action-button {
    min-width: 180px !important;
    height: 44px !important;
    font-size: 0.9rem !important;
  }
}

/* =================== OVERLAY =================== */
.v-overlay--active~.setup-container .sticky-save-btn {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

/* =================== COMPACT TEXT BUTTON STYLES =================== */
.compact-text-btn {
  min-width: 120px !important;
  height: 36px !important;
  font-size: 0.85rem !important;
  font-weight: 500 !important;
  text-transform: none !important;
  letter-spacing: 0.025em !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.compact-text-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
}

.compact-text-btn:active {
  transform: translateY(0) !important;
  transition: all 0.1s ease !important;
}

/* Platform-specific compact text variants */
.compact-text-btn.line-btn {
  background-color: #06c226 !important;
  color: white !important;
  border-color: #05a820 !important;
}

.compact-text-btn.line-btn:hover {
  background-color: #0ece2e !important;
  box-shadow: 0 2px 6px rgba(16, 185, 38, 0.25) !important;
}

.compact-text-btn.teams-btn {
  background-color: #403df1 !important;
  color: white !important;
  border-color: #613aed !important;
}

.compact-text-btn.teams-btn:hover {
  background-color: #2f3cfa !important;
  box-shadow: 0 2px 6px rgba(92, 95, 246, 0.25) !important;
}

.compact-text-btn.facebook-btn {
  background-color: #3b82f6 !important;
  color: white !important;
  border-color: #2563eb !important;
}

.compact-text-btn.facebook-btn:hover {
  background-color: #2563eb !important;
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.25) !important;
}

.compact-text-btn.instagram-btn {
  background-color: #ec4899 !important;
  color: white !important;
  border-color: #db2777 !important;
}

.compact-text-btn.instagram-btn:hover {
  background-color: #db2777 !important;
  box-shadow: 0 2px 6px rgba(236, 72, 153, 0.25) !important;
}

.compact-text-btn.snippet-btn {
  background-color: #f97316 !important;
  color: white !important;
  border-color: #ea580c !important;
}

.compact-text-btn.snippet-btn:hover {
  background-color: #ea580c !important;
  box-shadow: 0 2px 6px rgba(249, 115, 22, 0.25) !important;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .compact-text-btn {
    min-width: 100px !important;
    height: 32px !important;
    font-size: 0.8rem !important;
  }

  .compact-text-btn .v-icon {
    font-size: 16px !important;
  }
}

/* Extra compact variant */
.compact-text-btn.extra-compact {
  min-width: 90px !important;
  height: 30px !important;
  font-size: 0.75rem !important;
  padding: 0 12px !important;
}

.compact-text-btn.extra-compact .v-icon {
  font-size: 14px !important;
}
</style>
